import { EstateRagSimilarityDataMetadataObject } from '@/modules/ai/models/EstateRagSimilarityDataMetadataObject';
import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class EstateRagSimilarityDataObject extends BaseEntityModel {
  id?: string;
  blockId?: string;
  content?: string;
  metadata?: Relationship<EstateRagSimilarityDataMetadataObject | null>;

  constructor(model: Partial<EstateRagSimilarityDataObject> = {}) {
    super(model);

    this.id = model.id;
    this.blockId = model.blockId;
    this.content = model.content?.trim();
    this.metadata = EstateRagSimilarityDataMetadataObject.mapModelOrNull(model.metadata);
  }

  get parsedBlockId(): string {
    if (!this.blockId) {
      return '';
    }

    return this.blockId.replace(/-/g, '');
  }
}
